import styled from 'styled-components';

const VideoPanelContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default VideoPanelContainer;
